// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MlsPlanDate = require("../../common/MlsPlanDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let MlsPlanListingDetails_mlsPlan_graphql = require("../../../__generated__/MlsPlanListingDetails_mlsPlan_graphql.bs.js");

let convertFragment = MlsPlanListingDetails_mlsPlan_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MlsPlanListingDetails_mlsPlan_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MlsPlanListingDetails_mlsPlan_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MlsPlanListingDetails_mlsPlan_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MlsPlanListingDetails_mlsPlan_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function yesOrNo(value) {
  if (value) {
    return "Yes";
  } else {
    return "No";
  }
}

function toListingDetails(mlsPlan) {
  let match;
  switch (mlsPlan.__typename) {
    case "AlreadyOnMls" :
      match = [
        undefined,
        undefined,
        undefined
      ];
      break;
    case "ListOnMlsAsActive" :
      match = [
        Stdlib_Option.map(mlsPlan.onMlsAt, MlsPlanDate.formatDate),
        Stdlib_Option.map(mlsPlan.willShowPriorToMls, yesOrNo),
        Stdlib_Option.map(mlsPlan.willAcceptOffersPriorToMls, yesOrNo)
      ];
      break;
    case "ListOnMlsAsComingSoon" :
      match = [
        Stdlib_Option.map(mlsPlan.activeOnMlsOn, MlsPlanDate.formatDate),
        Stdlib_Option.map(mlsPlan.willShowPriorToMls, yesOrNo),
        Stdlib_Option.map(mlsPlan.willAcceptOffersPriorToMls, yesOrNo)
      ];
      break;
    case "NoMlsPlan" :
      match = [
        undefined,
        Stdlib_Option.map(mlsPlan.willShow, yesOrNo),
        Stdlib_Option.map(mlsPlan.willAcceptOffers, yesOrNo)
      ];
      break;
    case "__unselected" :
      match = UnselectedUnionMemberError.raise(`Unselected MLS Plan ` + mlsPlan._0);
      break;
  }
  return [
    Stdlib_Option.map(match[0], prim => prim),
    Stdlib_Option.map(match[1], prim => prim),
    Stdlib_Option.map(match[2], prim => prim)
  ];
}

let empty = [
  undefined,
  undefined,
  undefined
];

function use$1(mlsPlan) {
  return toListingDetails(RescriptRelay_Fragment.useFragment(MlsPlanListingDetails_mlsPlan_graphql.node, convertFragment, mlsPlan));
}

function useOpt$1(mlsPlan) {
  let mlsPlan$1 = useOpt(mlsPlan);
  if (mlsPlan$1 !== undefined) {
    return toListingDetails(mlsPlan$1);
  } else {
    return empty;
  }
}

exports.Fragment = Fragment;
exports.yesOrNo = yesOrNo;
exports.toListingDetails = toListingDetails;
exports.empty = empty;
exports.use = use$1;
exports.useOpt = useOpt$1;
/* MlsPlanDate Not a pure module */
